import React, { useEffect } from 'react';
import Button from '../Button';

/**
 * Full-screen image viewer overlay.
 * - Click the backdrop or the ✕ to dismiss.
 * - Press Escape to dismiss.
 */
export default function FullScreenImage({ url, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!url) return null;

  return (
    <div
      className="fullscreen-image-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        background: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <Button
        variant="ghost"
        iconOnly
        onClick={onClose}
        aria-label="Close image"
        style={{ position: 'absolute', top: '16px', right: '20px' }}
      >
        &times;
      </Button>
      <img
        src={url}
        alt="Full size attachment"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          borderRadius: '8px',
        }}
      />
    </div>
  );
}
